import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "node-status-text",
  "data-testid": "node-status-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    title: _ctx.node.attributes['ui:status:text'],
    class: _normalizeClass(_ctx.statusIconCss(_ctx.node.attributes)),
    style: _normalizeStyle(_ctx.statusIconStyle(_ctx.node.attributes))
  }, [
    (_ctx.node.attributes['ui:status:icon'])
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass([_ctx.glyphiconForName(_ctx.node.attributes['ui:status:icon']), "node-status-icon"])
        }, null, 2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      (_ctx.showText && _ctx.node.attributes['ui:status:text'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.node.attributes["ui:status:text"]), 1))
        : _createCommentVNode("", true)
    ], true)
  ], 14, _hoisted_1))
}